import type { Theme } from '@mui/material/styles';

type ConcreteColorScheme = 'light' | 'dark';

const resolveColorScheme = (
    mode?: string | null,
    systemMode?: string | null
): ConcreteColorScheme => {
    const resolvedMode = mode === 'system' ? systemMode : mode;

    return resolvedMode === 'light' ? 'light' : 'dark';
};

/**
 * Returns concrete colors for APIs such as Canvas and Stripe that cannot resolve
 * the CSS-variable tokens exposed by `theme.vars`.
 */
export const getConcretePalette = (
    theme: Theme,
    mode?: string | null,
    systemMode?: string | null
) =>
    theme.colorSchemes?.[resolveColorScheme(mode, systemMode)]?.palette ??
    theme.palette;
